import { appContent } from '@/mocks/homepage';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-600 via-primary-500 to-accent-600 rounded-2xl p-6 md:p-10 flex flex-col lg:flex-row items-center gap-6 md:gap-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-black text-white mb-3">{appContent.title}</h2>
            <p className="text-sm md:text-base text-white/90 mb-4 md:mb-5">{appContent.subtitle}</p>
            <ul className="space-y-2 mb-5 md:mb-6">
              {appContent.features.map((f) => (
                <li key={f} className="flex items-center gap-2 text-white/80 text-sm">
                  <i className="ri-check-line text-accent-300"></i>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#"
                className="flex items-center gap-2 px-5 py-3 bg-white text-primary-600 font-bold rounded-lg hover:bg-white/90 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
                onClick={(e) => e.preventDefault()}
              >
                <i className="ri-apple-fill text-lg"></i>
                <span>iOS 下载</span>
              </a>
              <a
                href="#"
                className="flex items-center gap-2 px-5 py-3 bg-white/20 text-white font-bold rounded-lg hover:bg-white/30 transition-colors duration-200 border border-white/30 text-sm whitespace-nowrap cursor-pointer"
                onClick={(e) => e.preventDefault()}
              >
                <i className="ri-android-fill text-lg"></i>
                <span>Android 下载</span>
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20vibrant%20colorful%20app%20interface%20with%20dark%20theme%20and%20warm%20accent%20colors%2C%20elegant%20minimal%20design%2C%20floating%20phone%20on%20clean%20transparent%20background%2C%20no%20text%20visible%2C%20sleek%20premium%20device%20with%20glossy%20screen%20reflection&width=400&height=533&seq=app-mockup&orientation=portrait"
                alt="爆料专区 App 移动端"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}